import React from 'react';
import { Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AvailableShiftCardProps {
  id: string;
  location: string;
  date: string;
  time: string;
  note?: string;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const AvailableShiftCard: React.FC<AvailableShiftCardProps> = ({
  id,
  location,
  date,
  time,
  note,
  isSelected,
  onSelect
}) => {
  const navigate = useNavigate();

  const handleInfoClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the card selection
    navigate(`/open-shift-details/${id}`);
  };

  return (
    <div 
      className={`mt-5 rounded-2xl border-2 cursor-pointer transition-all duration-200 ${
        isSelected 
          ? 'border-blue-500 bg-blue-50' 
          : 'border-gray-200 hover:border-gray-300'
      } shadow-[0_1px_2px_rgba(0,0,0,0.05)] p-5`}
      onClick={() => onSelect(id)}
    >
      <div className="flex items-center">
        {/* Left content */}
        <div className="flex-1">
          <p className="text-[20px] leading-7 font-normal text-gray-800">{location}</p>
          <p className="mt-2 text-[16px] leading-6 text-gray-500">{date}</p>
          <p className="mt-2 text-[16px] leading-6 text-gray-500">{time}</p>
          {note && (
            <p className="mt-2 text-[16px] leading-6 text-gray-500">{note}</p>
          )}
        </div>
        
        {/* Info icon */}
        <button
          onClick={handleInfoClick}
          className="ml-3 p-2 hover:bg-gray-100 rounded-full transition-colors"
          title="View Details"
        >
          {/* <Info className="h-5 w-5 text-gray-500 hover:text-gray-700" /> */}
        </button>
      </div>
    </div>
  );
};

export default AvailableShiftCard;
